// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__K2V2s","loadingShrink":"PageLoading_loadingShrink__3omr_"};